// Wizard Filters
import ContentFilter from '../wizard/filters/ContentFilter';
import TaxonomyFilter from '../wizard/filters/TaxonomyFilter';
import WorkflowFilter from '../wizard/filters/WorkflowFilter';
import BoardFilter from '../wizard/filters/BoardFilter';
import ToolFilter from '../wizard/filters/ToolFilter';
import AdminFilter from '../wizard/filters/AdminFilter';
import SiteFilter from '../wizard/filters/SiteFilter';

export const getContentEditorPermissions = ({ id }) => ([
  {
    action: 'access',
    page: 'content.editor',
    id,
  },
  {
    action: 'update',
    entity: 'content',
    id,
  },
  {
    action: 'delete',
    entity: 'content',
    id,
  },
  {
    action: 'publish',
    entity: 'content',
    id,
  },
  {
    action: 'unpublish',
    entity: 'content',
    id,
  },
]);

// Available resources form PermissionEditor
export const resources = [
  'boards',
  'contents',
  'taxonomies',
  // This resource is optional on projects. Should be activated on project configuration
  // 'workflow',
  'tools',
  'admin',
  'sites',
];

export const resourceFilters = {
  boards: [
    BoardFilter,
    TaxonomyFilter,
  ],
  contents: [
    ContentFilter,
    TaxonomyFilter,
  ],
  taxonomies: [
    TaxonomyFilter,
  ],
  workflow: [
    WorkflowFilter,
  ],
  tools: [
    ToolFilter,
  ],
  admin: [
    AdminFilter,
  ],
  sites: [
    SiteFilter,
  ],
};

export const resourceActions = {
  boards: [
    'create',
    'edit',
    'publish',
    'unpublish',
    'delete',
  ],
  contents: [
    'create',
    'clone',
    'edit',
    'editChannels',
    'editTags',
    'publish',
    'unpublish',
    'delete',
  ],
  taxonomies: [
    'create',
    'edit',
    'delete',
  ],
  workflow: [
    'edit',
  ],
  tools: [
    'access',
  ],
  admin: [
    'access',
  ],
  sites: [
    'access',
    'edit',
  ],
};

// Table Header by resource for PermissionsEditor
export const resourceHeaders = {
  boards: ['action', 'type', 'category', 'origin', null],
  contents: ['action', 'type', 'category', 'origin', null],
  taxonomies: ['action', 'type', 'origin', null],
  workflow: ['action', 'state', 'origin', null],
  tools: ['action', 'tool', 'origin', null],
  admin: ['action', 'page', 'origin', null],
  sites: ['action', 'site', 'origin', null],
};

export const toolFilterAvailableTools = [
  'comments', 'seo', 'right_column', 'alerts', 'advertising', 'dayparting', 'social_network_accounts',
];

export const toolFilterAvailableAdmin = [
  'paywall_admin', 'users_admin', 'staff_admin', 'roles_admin',
];


export default {
  getContentEditorPermissions,
  resourceHeaders,
  resourceFilters,
  resourceActions,
  toolFilterAvailableTools,
  toolFilterAvailableAdmin,
};
